<p>{{ 'tiers.upgrade.MULTIPLE_ALISTS' | translate }}</p>

<div class="h-button-wrapper">
  <button axButton (click)="cancel.emit()">{{ 'label.cancel' | translate }}</button>
  <al-upgrade-tier-button color="primary" filled (click)="upgrade.emit()"></al-upgrade-tier-button>
</div>
